import script from "./AdminLoginView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLoginView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__